const MaritalStatusValues = {
    SINGLE: 'single',
    IN_RELATIONSHIP: 'in_relationship',
    MARRIED: 'married',
    SEPARATED: 'separated',
    DIVORCED: 'divorced',
    WIDOWED: 'widowed',
    COMMON_LAW: 'common_law',
};

export default MaritalStatusValues;
